// src/components/CallToAction.jsx
export default function CallToAction() {
  return (
    <section className="py-12">
      <div className="max-w-6xl mx-auto px-4">
        <div className="bg-slate-900 text-white rounded-2xl border border-white/10 p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div>
            <h3 className="font-serif text-2xl">
              Don’t Wait — Legal Deadlines Are Approaching
            </h3>
            <p className="text-white/70 mt-1">
              Evidence fades with time. Start your claim risk-free today.
            </p>
          </div>
          <a
            href="#form"
            className="bg-yellow-500 text-slate-900 font-semibold px-5 py-3 rounded-lg"
          >
            Start Free Case Review
          </a>
        </div>
      </div>
    </section>
  );
}
